import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddContactModal from './AddContactModal';
import QuickLogModal from './QuickLogModal';

export default function FloatingActionButton() {
  const [expanded, setExpanded] = useState(false);
  const [showAddContact, setShowAddContact] = useState(false);
  const [showQuickLog, setShowQuickLog] = useState(false);
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Add Contact',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <line x1="19" x2="19" y1="8" y2="14" />
          <line x1="22" x2="16" y1="11" y2="11" />
        </svg>
      ),
      onClick: () => {
        setExpanded(false);
        setShowAddContact(true);
      },
    },
    {
      label: 'Log Activity',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 20h9" />
          <path d="M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z" />
        </svg>
      ),
      onClick: () => {
        setExpanded(false);
        setShowQuickLog(true);
      },
    },
    {
      label: 'New Deal',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
          <polyline points="16 7 22 7 22 13" />
        </svg>
      ),
      onClick: () => {
        setExpanded(false);
        navigate('/pipeline');
      },
    },
  ];

  return (
    <>
      {/* Backdrop when expanded */}
      {expanded && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setExpanded(false)}
        />
      )}

      {/* Speed dial actions */}
      <div className="fixed z-50 flex flex-col items-end gap-3"
        style={{ bottom: 'calc(env(safe-area-inset-bottom, 0px) + 88px)', right: '16px' }}
      >
        {expanded && actions.map((action, i) => (
          <div key={i} className="flex items-center gap-3" style={{ animation: 'fade-in 0.15s ease-out' }}>
            <span
              className="px-3 py-1.5 rounded-lg text-xs font-body whitespace-nowrap"
              style={{ background: '#141414', color: 'var(--text-primary)', border: '1px solid var(--border-primary)' }}
            >
              {action.label}
            </span>
            <button
              onClick={action.onClick}
              className="w-12 h-12 rounded-full flex items-center justify-center cursor-pointer transition-all shadow-lg"
              style={{
                background: '#141414',
                color: 'var(--netrun-green)',
                border: '1px solid var(--border-primary)',
              }}
            >
              {action.icon}
            </button>
          </div>
        ))}

        {/* Main FAB */}
        <button
          onClick={() => setExpanded(!expanded)}
          className="w-14 h-14 rounded-full flex items-center justify-center cursor-pointer transition-all duration-200 shadow-lg"
          style={{
            background: 'var(--netrun-green)',
            color: 'var(--netrun-black)',
            border: 'none',
            transform: expanded ? 'rotate(45deg)' : 'rotate(0)',
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" x2="12" y1="5" y2="19" />
            <line x1="5" x2="19" y1="12" y2="12" />
          </svg>
        </button>
      </div>

      {/* Modals */}
      <AddContactModal
        open={showAddContact}
        onClose={() => setShowAddContact(false)}
        onSuccess={() => setShowAddContact(false)}
      />
      <QuickLogModal
        open={showQuickLog}
        onClose={() => setShowQuickLog(false)}
      />
    </>
  );
}
